import { FC } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

export interface TermPageProps {
  className?: string;
}

const TermPage: FC<TermPageProps> = ({ className = "" }) => {
  const { t } = useTranslation();

  return (
    <div className={`nc-ProfilePage ${className}`} data-nc-id="AuthorPage">
      <Helmet>
        <title>Flying Lab</title>
      </Helmet>
      <main className="container mt-12 mb-24 lg:mb-32 flex flex-col lg:flex-row">
        <div className="block flex-grow mb-24 lg:mb-0">
          <div className="lg:sticky lg:top-24">
            <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 h-full">
              <div className=" mb-5 px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                <div className="space-y-3 sm:space-y-3">
                  {/* HEADING */}
                  <h2 className="text-xl font-semibold">{t("cancellation_or_no_show_title")}</h2>
                  <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
                  <div className="flex flex-col md:flex-row">
                    <p className="text-sm text-neutral-60">{t("cancellation_or_no_show_1")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("cancellation_or_no_show_2")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("cancellation_or_no_show_3")}</p>
                    <br />
                  </div>

                  <h2 className="text-xl font-semibold">{t("personal_data_collection_title")}</h2>
                  <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
                  <div className="flex flex-col md:flex-row">
                    <p className="text-sm text-neutral-60">{t("personal_data_collection_main")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("personal_data_collection_1_start")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">• {t("personal_data_collection_1a")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">• {t("personal_data_collection_1b")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("personal_data_collection_1_end")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("personal_data_collection_2")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("personal_data_collection_3")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("personal_data_collection_4")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("personal_data_collection_5")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("personal_data_collection_6")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("personal_data_collection_7")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("personal_data_collection_footer")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("personal_data_collection_thanks")}</p>
                    <br />
                  </div>
                  <h2 className="text-xl font-semibold">{t("disclaimer_title")}</h2>
                  <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
                  <div className="flex flex-col md:flex-row">
                    <p className="text-sm text-neutral-60">{t("disclaimer_1")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("disclaimer_2")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("disclaimer_3")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("disclaimer_4")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("disclaimer_5")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("disclaimer_6")}</p>
                    <br />
                    <p className="text-sm text-neutral-60">{t("disclaimer_7")}</p>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermPage;
